<template>
  <div class="pdf">
    <span>作业指导书</span>
    <el-divider/>
    <div class="btnGroup">
      <el-button type="primary" @click.stop="scaleD">放大</el-button>
      <el-button type="primary" @click.stop="scaleX">缩小</el-button>
      <el-button type="primary" @click="fileDownload(pdfUrl, 'pdf文件')">下载</el-button>
      <el-button type="primary" @click="pdfPrint()">打印当前页</el-button>
      <el-button type="primary" @click="pdfPrintAll()">打印所有页</el-button>
      <el-button type="primary" @click.stop="prePage">上一页</el-button>
      <el-button type="primary" @click.stop="nextPage">下一页</el-button>
      <el-button v-if="!flag" type="primary" @click="fullScreen">全屏</el-button>
      <el-button v-if="flag" type="primary" @click="fullScreen">还原</el-button>
    </div>
    <div class="show">
      <pdf
          ref="pdf"
          :src="pdfUrl"
          :page="pageNum"
          :rotate="pageRotate"
          @password="password"
          @progress="loadedRatio = $event"
          @page-loaded="pageLoaded($event)"
          @num-pages="pageTotalNum = $event"
          @error="pdfError($event)"
          @link-clicked="page = $event"/>
    </div>
    <div class="pdf_footer">
      <div class="info"/>
      <div class="operate">
        <div>当前页：{{pageNum}}</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
  import pdf from "vue-pdf";
  export default {
    name: "vue_pdf_preview",
    props: {
      // 当前pdf路径
      pdfUrl: {
        type: String,
        default: "",
      },
      // 当前页码
      pageNum: {
        type: Number,
        default: 1,
      },
    },
    components: {
      pdf,
    },
    data() {
      return {
        flag: false,
        // 总页数
        pageTotalNum: 1,
        // 加载进度
        loadedRatio: 0,
        // 页面加载完成
        curPageNum: 0,
        // 放大系数 默认百分百
        scale: 100,
        // 旋转角度 ‘90’的倍数才有效
        pageRotate: 0,
        // 单击内部链接时触发 (目前我没有遇到使用场景)
        page: 0,
      };
    },
    methods: {
      //下载PDF
      fileDownload(data, fileName) {
        window.open(this.pdfUrl);
      },
      fullScreen() {
        this.flag = !this.flag;
        this.$emit("isFullScreen", this.flag);
      },
      scaleD() {
        this.scale += 5;
        this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
      },

      //缩小
      scaleX() {
        // scale 是百分百展示 不建议缩放
        if (this.scale == 100) {
          return;
        }
        this.scale += -5;
        this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
      },
      // 切换上一页
      prePage() {
        var p = this.pageNum;
        p = p > 1 ? p - 1 : this.pageTotalNum;
        this.pageNum = p;
      },
      // 切换下一页
      nextPage() {
        var p = this.pageNum;
        p = p < this.pageTotalNum ? p + 1 : 1;
        this.pageNum = p;
      },
      // 顺时针选中角度
      clock() {
        this.pageRotate += 90;
      },
      // 逆时针旋转角度
      counterClock() {
        this.pageRotate -= 90;
      },
      // pdf 有密码 则需要输入秘密
      password(updatePassword, reason) {
        updatePassword(prompt('password is "test"'));
      },
      // 页面加载成功  当前页数
      pageLoaded(e) {
        this.$emit("current", e);
        this.curPageNum = e;
      },
      // 异常监听
      pdfError(error) {
        console.error(error);
      },
      // 打印所有
      pdfPrintAll() {
        this.$refs.pdf.print();
      },
      // 打印 第一页和第二页
      pdfPrint() {
        // 第一个参数 文档打印的分辨率
        // 第二个参数 文档打印的页数
        this.$refs.pdf.print(100, [5]);
      },
    },
  };
</script>

<style lang="scss" scoped>
.pdf {
  .btnGroup {
    text-align: left;
    margin-bottom: 10px;
    margin-right: 8px;
  }
  .show {
    overflow: auto;
    margin: auto;
    max-width: 100%;
    height: 76vh;
  }
  .pdf_footer {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 10px 0;
    background-color: rgba(255, 255, 255, 0.5);
    .info {
      display: flex;
      flex-wrap: wrap;
      div {
        width: 30%;
      }
    }
    .operate {
      text-align: center;
      padding-top: 10px;
    }
  }
}
</style>
